import React from 'react';
import KeyBinder from '../../utils/KeyBinder';

export class Dropdown extends React.Component {

	constructor(props){
        super(props);       
        this.state = { 
            open : false
        }
    }

    componentDidMount(){
         this.keyBinder = new KeyBinder({escapePressed: this.closePopupIfOpen.bind(this)});
    }

    componentWillUnmount(){
        this.keyBinder.destroy();
    }

    closePopupIfOpen(){
    	if (this.state.open){
    		this.setState({
				open : false
			});
    	}
    }

	toggleDropdown(e){		
		this.setState({
			open : ! this.state.open
		});
	}

    render() {
    	var openClass = this.state.open ? 'open ' : '';
    	var pullRightClass = this.props.pullRight ? 'pull-right ' : '';
    	var activeClass = this.state.open ? 'active ' : '';

        var dropdownStyle = Object.assign({marginTop: '0px'}, this.props.dropdownStyle);

        return (
             <div style={this.props.style} className={"input-group-btn " + openClass + pullRightClass + this.props.className} onMouseLeave={this.closePopupIfOpen.bind(this)}>
                <button type="button" className={"btn btn-primary dropdown-toggle " + activeClass} data-toggle="dropdown" onClick={this.toggleDropdown.bind(this)}>
                 {this.props.iconName && <i className={"fa fa-" + this.props.iconName}></i>} {this.props.dropDownTitle} 
                 <span className="caret"></span></button>
                <ul className="dropdown-menu" style={dropdownStyle}>
                	{this.props.children}
                </ul>
            </div>
               
        );
    }
}

export class DropdownItem extends React.Component {	

	btnClick(e){
        if(this.props.onClick) {
            this.props.onClick();
        }

		e.preventDefault();
	}

    render() {
        return (
			<li className={'dropdown-item' + this.props.className}>
			    <a onClick={this.btnClick.bind(this)}>{this.props.children}</a>
			</li>
        );
    }
}

export class DropdownDivider extends React.Component {
    render() {
        return (
			<li className="divider"></li>
        );
    }
}

export class DropdownHeader extends React.Component {
    render() {
        return (
			<li className="dropdown-header">{this.props.children}</li>
        );
    }
}





// WEBPACK FOOTER //
// ./app/components/bootstrap/Dropdown.js